import {
  type APITriplet,
  type ModelTriplet,
  RDK_MODEL_NAME_BUILTIN,
} from '$lib/resource-type';

import { isBuiltinAPI } from './api-types';
import { isBuiltinModel } from './models';
import { ServiceSubtypes } from './services';

export const isBuiltinNavigationService = (
  api: APITriplet,
  model: ModelTriplet
) =>
  isBuiltinAPI(api, ServiceSubtypes.NAVIGATION) &&
  isBuiltinModel(model, RDK_MODEL_NAME_BUILTIN);
